import { useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import "./pickup.css";
import QrCodeScanner from "./QrCodeScanner.jsx";
import { useDevices } from "@yudiel/react-qr-scanner";
const PickupStudentScanMobile = () => {
  const location = useLocation();
  const devices = useDevices();

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  const handleRefresh = async () => {};

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[calc(100vh-136px)]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-1 w-full h-full">
              {devices ? (
                <QrCodeScanner devices={devices}></QrCodeScanner>
              ) : (
                "No devices found"
              )}
            </section>
          </div>
        </PullToRefresh>
      </div>
    </>
  );
};

export default PickupStudentScanMobile;
